import { useSearchParams } from 'react-router-dom';

const VALID_TABS = ['tools', 'members'];

/**
 * Reads/writes the active department tab from the URL ?tab= query param.
 * Unknown or missing values resolve to 'tools'.
 */
export function useDeptTabParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('tab');
  const tab = VALID_TABS.includes(raw) ? raw : 'tools';

  const setTab = (next) => {
    const params = new URLSearchParams(searchParams);
    if (next === 'tools') {
      params.delete('tab');
    } else {
      params.set('tab', next);
    }
    setSearchParams(params, { replace: true });
  };

  return { tab, setTab };
}
